import { z } from "zod";

/** Column keys the table can sort by, plus the blended default "relevance". */
export const SORT_KEYS = [
  "relevance",
  "title",
  "cat",
  "risk",
  "rating",
  "downloads",
  "updated",
  "author",
] as const;
export type SortKey = (typeof SORT_KEYS)[number];

/**
 * Search params shared by Discover (`/`) and All Skills (`/skills`). Lifting
 * sort + filters + query into the URL makes a sorted/filtered table shareable
 * and back-button friendly. All fields optional so unfiltered URLs stay clean;
 * consumers apply defaults (sort=relevance, dir=desc, view=table).
 */
export const discoverySearchSchema = z.object({
  q: z.string().optional(),
  cat: z.enum(["UI/UX", "Security", "Efficiency"]).optional(),
  risk: z.array(z.enum(["vetted", "low", "review", "high"])).optional(),
  minRating: z.number().optional(),
  freshness: z.number().optional(),
  authors: z.array(z.string()).optional(),
  sort: z.enum(SORT_KEYS).optional(),
  dir: z.enum(["asc", "desc"]).optional(),
  view: z.enum(["table", "grid"]).optional(),
});

export type DiscoverySearch = z.infer<typeof discoverySearchSchema>;
